import React from "react"
import {BannerContainer, BannerBackToSite, Logo, TextWrapper, BannerWrapper} from "./components"
import connect from "./connect"
import {ElementModel} from "../../models/headerModel"
import {formatCdnPath} from "../../utils/getCdnUrl"
import {CHEVRON_WHITE_ICON_URL} from "../../config/constants"

export type BackToAlertProps = {
    banner: ElementModel | null
    displayBanner: boolean
}

export const redirect = (url: string | null) => {
    const newUrl = url || ""
    window.location.href = newUrl
}

export const BackToSiteBanner = ({banner, displayBanner}: BackToAlertProps) => {
    const {icon, url, text} = banner || {}
    return displayBanner && banner && icon && url && text ? (
        <BannerWrapper>
            <BannerContainer data-testid="header-back-to-site-banner-container">
                <BannerBackToSite onClick={() => redirect(url)} data-testid="header-back-to-site-banner">
                    <img src={formatCdnPath(CHEVRON_WHITE_ICON_URL)} alt="chevron" />
                    <TextWrapper>{text}</TextWrapper>
                    <Logo src={formatCdnPath(icon)} alt="logo" />
                </BannerBackToSite>
            </BannerContainer>
        </BannerWrapper>
    ) : null
}

export default connect(BackToSiteBanner)
